import { render, staticRenderFns } from "./CategoryMultiSelect.vue?vue&type=template&id=4f862a01&scoped=true&"
import script from "./CategoryMultiSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMultiSelect.vue?vue&type=style&index=0&id=4f862a01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f862a01",
  null
  
)

export default component.exports